
  import { Vue, Component, Prop } from "vue-property-decorator";

  import AddPaymentCardForm from "@/components/payment/AddPaymentCardForm.vue";
  import PaymentOptionsList from "@/components/payment/PaymentOptionsList.vue";

  import lambdaRequest from "@/helpers/lambdaRequest";
  import Message from "@/data/notificationsMessages";

  import { NOTIFICATION } from "@/entities/Events";
  import { Payment_Card } from "@/generated/graphql";

  @Component({
    components: {
      PaymentOptionsList,
      AddPaymentCardForm,
    },
  })
  export default class UpdateSubscriptionOptions extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly chosenSubscriptionPlanId!: string;
    @Prop({ type: String, required: true }) readonly cardFormTitle!: string;
    @Prop({ type: String, required: true }) readonly cardsListTitle!: string;
    @Prop({ type: Boolean, required: true }) readonly isPaymentCardsExist!: boolean;
    @Prop({ type: Array, required: true }) readonly paymentCards!: Payment_Card[];

    applyingChosenCard: boolean = false;
    editingCard: boolean = false;
    errorMessage: string = "";

    async reSubscribeWithNewCard(payload: { token: string }): Promise<void> {
      this.editingCard = true;
      const { token } = payload;

      try {
        await lambdaRequest({
          lambdaName: this.isPaymentCardsExist ? "reSubscribeWithUpdatedCard" : "reSubscribeWithNewCard",
          requestData: {
            token,
            subscription_plan_id: this.chosenSubscriptionPlanId,
          },
        });

        this.$emit("subscriptionUpdated");
      } catch (error) {
        this.errorMessage = error.message;
      } finally {
        this.editingCard = false;
      }
    }

    async reSubscribeWithExistingCard(cardId: string): Promise<void> {
      this.applyingChosenCard = true;
      try {
        await lambdaRequest({
          lambdaName: "reSubscribeWithExistingCard",
          requestData: {
            card_id: cardId,
            subscription_plan_id: this.chosenSubscriptionPlanId,
            user_id: this.currentUserId,
          },
        });

        this.$emit("subscriptionUpdated");
      } catch (error) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error.message));
      } finally {
        this.applyingChosenCard = false;
      }
    }
  }
